export const projectInfo = {
  name: "halolight",
  author: "h7ml",
  repo: "https://github.com/halolight/halolight-react",
  homepage: "https://halolight.h7ml.cn",
  desc: "基于 Next.js 14 的现代化中文后台管理系统",
}
